import React from 'react';
import { t } from 'i18next';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import XIcon from '../../../assets/icons/x_icon.svg';
import PrimaryButton from '../buttons/PrimaryButton';
import SecondaryButton from '../buttons/SecondaryButton';
import {
  CloseContainer,
  ModalBody,
  ModalTitlesContainer,
  ModalTitle,
  ModalSubTitle,
  ModalChildren,
  ButtonsWrapper,
} from './css';

const AppModal = ({ children, ...props }) => {
  const {
    handleClose, isOpen, title, subtitle, support, actions, isAuthenticated, closeCallback,
  } = props;

  const closeModal = () => {
    if (closeCallback) {
      handleClose(closeCallback);
    } else {
      handleClose();
    }
  };

  const defaultButton = [
    {
      label: t('Close'),
      type: 'primary',
      action: closeModal,
      arrow: false,
    },
  ];

  const buttons = (actions) || defaultButton;
  buttons.sort((a, b) => {
    const result = (a.type > b.type) ? -1 : 1;
    return result;
  });

  // eslint-disable-next-line react/no-unstable-nested-components
  const ErrorBlock = () => {
    const LTLCustomerNumber = 'LTL: 1.866.Day.Ross (329-7677)';
    const CommerceCustomerNumber = 'Commerce: 1.877.726.3329';

    return (
      <ModalChildren>
        <p><strong>{support}</strong></p>
        <p>{t('PleaseContactCustomerService')}</p>
        {
                    (isAuthenticated)
                      ? (
                        <>
                          <p>{LTLCustomerNumber}</p>
                          <p>{CommerceCustomerNumber}</p>
                        </>
                      ) : null
                }
      </ModalChildren>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel="Modal"
      className="the_modal"
      overlayClassName="the_modal_overlay"
    >

      <CloseContainer>
        <img src={XIcon} alt={t('Close')} onClick={closeModal} aria-hidden />
      </CloseContainer>

      <ModalBody>

        <ModalTitlesContainer>

          {(title) ? <ModalTitle>{title}</ModalTitle> : null }
          {(subtitle) ? <ModalSubTitle>{subtitle}</ModalSubTitle> : null }
          {(support) ? <ErrorBlock /> : null}
          { (children) ? <ModalChildren>{children}</ModalChildren> : null}

        </ModalTitlesContainer>

        <ButtonsWrapper unique={(buttons.length === 1)}>
          { buttons.map((btn, index) => {
            if (btn.type === 'primary') {
              return (
                <PrimaryButton key={`Modal-Button-${index}`} label={btn.label} onClick={btn.action} showArrow={btn.arrow} />
              );
            }

            return (
              <SecondaryButton key={`Modal-Button-${index}`} label={btn.label} onClick={btn.action} showArrow={btn.arrow} />
            );
          })}
        </ButtonsWrapper>

      </ModalBody>

    </Modal>
  );
};

AppModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  support: PropTypes.string,
  actions: PropTypes.array,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isAuthenticated: PropTypes.bool,
  closeCallback: PropTypes.func,
};

export default AppModal;
